<template>
  <router-link
    :to="$i18nRoute({ name: 'dashboard' })"
    class="flex items-center justify-center gap-2 px-4 py-3 text-base text-white/80 transition-colors hover:text-white md:px-3 md:py-2 md:text-sm"
  >
    <i class="hf hf-dashboard hf-fw hf-lg" />
    {{ $t('components.top_nav.dashboard') }}
  </router-link>
</template>

<script>
/**
 * @module JournalistDashboardLink
 */
export default {
  name: 'JournalistDashboardLink'
}
</script>
